import {
  findNodeById,
  RuleApplyResult,
  setNodeActiveById,
} from "../../../../components/ReportChapterTree/reportChaptersTreeUtils";
import { IReportChapterNode } from "../../../../mc-shared/reportSchemas/kapitelSchema";

export const ruleSporbarhetRequired = (kapitler: IReportChapterNode[]): RuleApplyResult => {
  let out = kapitler;
  const messages: string[] = [];

  const hasMalinger = Boolean(findNodeById(out, "grunnlagMalinger")?.isActive);
  const hasFoto = Boolean(findNodeById(out, "vedleggFoto")?.isActive);

  if (hasMalinger && hasFoto) {
    const sporbarhet = findNodeById(out, "sporbarhet");
    if (sporbarhet?.isActive !== true) {
      out = setNodeActiveById(out, "sporbarhet", true);

      messages.push("Sporbarhet ble krysset av automatisk fordi både 'Målinger' og 'Fotodokumentasjon' er valgt.");
    }
  }

  return { kapitler: out, messages };
};

export const applyEksempelStickyRules = (kapitler: IReportChapterNode[]): RuleApplyResult => {
  let out = kapitler;
  const messages: string[] = [];

  const rules = [
    ruleSporbarhetRequired,
    // ruleXxx,
    // ruleYyy,
  ];

  for (const r of rules) {
    const res = r(out);
    out = res.kapitler;
    messages.push(...res.messages);
  }

  // undvik dubletter om flera regler råkar ge samma text
  const uniqueMessages = Array.from(new Set(messages));

  return { kapitler: out, messages: uniqueMessages };
};

// Hjälpare: kör en regel och merge:a ihop resultat
const mergeRule = (acc: RuleApplyResult, next: RuleApplyResult): RuleApplyResult => ({
  kapitler: next.kapitler,
  messages: [...acc.messages, ...next.messages],
});

export const applyAllRules = (kapitler: IReportChapterNode[]): RuleApplyResult => {
  let acc: RuleApplyResult = { kapitler, messages: [] };

  acc = mergeRule(acc, applyEksempelStickyRules(acc.kapitler));
  // acc = mergeRule(acc, applyAnotherRule(acc.kapitler));
  // acc = mergeRule(acc, applyThirdRule(acc.kapitler));

  // undvik dubletter
  acc.messages = Array.from(new Set(acc.messages));

  return acc;
};